export type LoginResult = "ok" | "userNotFound" | "invalidPassword" | "internalError";

export const loginResultStatusCodes = new Map<LoginResult, number>([
    ["ok", 200],
    ["userNotFound", 404],
    ["invalidPassword", 401],
    ["internalError", 500]
])

export const getStatusCodeResult = (status: number) => [...loginResultStatusCodes].find(e => e[1] === status)?.[0]